<template>
  <section>
    <qx-search-box
        className="searchBox"
        ref="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        @reset="reset"
        title="筛选"
        permpisionsQuery
    />
    <TableBox ref="tableBox"/>
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
import {
  getAccessoryNameList,
  getAccessoryModelList,
} from 'api/service';

export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        operationTypeOptions: [], // 出入库类型
        accessoryNameOptions: [], // 配件名称
        accessoryModelOptions: [], // 配件型号
        form: [
          {
            label: '日期',
            value: 'outboundObjectsDate',
            type: 'date',
            placeholder: '请选择日期',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '类型',
            value: 'operationType',
            type: 'select',
            default: '-1',
            placeholder: '请选择类型',
          },
          {
            label: '配件名称',
            value: 'accessoryName',
            type: 'select',
            filterable: true,
            default: -1,
            placeholder: '请选择配件名称',
            onChange: (accessoryName) => {
              this.handleAccessoryNameChange(accessoryName);
            },
          },
          {
            label: '配件型号',
            value: 'accessoryModel',
            type: 'select',
            filterable: true,
            default: -1,
            placeholder: '请选择配件型号',
          },
        ],
      },
    };
  },
  watch: {
    '$route.path': function (val) {
      if (val === '/manage/service/inventoryManagement/inventoryDetail') {
        this.getEnum('noFirst');
      }
    },
  },
  methods: {
    reset () {
      this.searchBoxData.accessoryModelOptions = [
        {
          label: '全部',
          value: -1,
        },
      ];
    },
    async getEnum (val) {
      const enumsList = await getEnumList({
        codeType: 'INVENTORY_OPER_TYPE',
      });
      this.searchBoxData.operationTypeOptions = [
        {
          label: '全部',
          value: '-1',
        },
        ...enumsList[0],
      ];
      const accessoryName = await getAccessoryNameList({
        accessoryName: '',
      });
      this.searchBoxData.accessoryNameOptions = [
        {
          label: '全部',
          value: -1,
        },
        ...accessoryName,
      ];
      if (!val) { // 已经打开过该菜单则不调“配件型号”枚举接口
        await this.handleAccessoryNameChange();
      }
    },
    async handleAccessoryNameChange (accessoryName) {
      if (accessoryName) {
        this.$refs.searchBox.setVal('accessoryModel', -1);
        let data = this.searchBoxData.accessoryNameOptions.find((item) => item.value === accessoryName);
        const accessoryModelRes = await getAccessoryModelList({
          accessoryName: data.label,
        });
        this.searchBoxData.accessoryModelOptions = [
          {
            label: '全部',
            value: -1,
          },
          ...accessoryModelRes,
        ];
      } else {
        this.searchBoxData.accessoryModelOptions = [
          {
            label: '全部',
            value: -1,
          },
        ];
      }
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 日期
      if (searchBoxData.outboundObjectsDate && searchBoxData.outboundObjectsDate.length > 0) {
        searchBoxData.startDate = this.formatDate(searchBoxData.outboundObjectsDate[0]);
        searchBoxData.endDate = this.formatDate(searchBoxData.outboundObjectsDate[1]);
      }
      delete searchBoxData.outboundObjectsDate;
      // 配件名称
      let accessoryName = this.searchBoxData.accessoryNameOptions.find((item) => item.value === Number(this.$refs.searchBox.getVal('accessoryName')));
      searchBoxData.accessoryName = this.$refs.searchBox.getVal('accessoryName') !== -1 ? accessoryName.label : '';
      // 配件型号
      let accessoryModel = this.searchBoxData.accessoryModelOptions.find((item) => item.value === Number(this.$refs.searchBox.getVal('accessoryModel')));
      searchBoxData.accessoryModel = this.$refs.searchBox.getVal('accessoryModel') !== -1 ? accessoryModel.label : '';
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.getEnum();

  },
};
</script>

<style lang="scss" scoped>
</style>
